import { ata } from './client.js';

/** A corporacao ja tem as tabelas do ata? Responde 200 mesmo enquanto o resto da API responde 503 (corporation_not_ready): e o que a tela de espera consulta. */
export const getReadiness = () => ata({ url: '/readiness' });

/* Entrada local de desenvolvimento -- 404 quando ATA_LOCAL_LOGIN e false. */
export const localLogin = ({ userId, corp }) =>
    ata({ method: 'post', url: '/dev/login', body: { user_id: userId, corp } });
